import { Question, QuestionFactory, Serializer } from "survey-core";
import { ReactQuestionFactory } from "survey-react-ui";

const QUESTION_TYPE = "visitdatepicker";
let isRegistered = false;

/* =========================================================
   QUESTION MODEL - Standalone Date Picker
========================================================= */
class QuestionVisitDatePickerModel extends Question {
  constructor(name) {
    super(name);

    // Set default properties
    this.setPropertyValue("placeholder", "Select visit date");
    this.setPropertyValue("minDate", "");
    this.setPropertyValue("maxDate", "");
    this.setPropertyValue("value", null);
  }

  getType() {
    return QUESTION_TYPE;
  }

  // Placeholder
  get placeholder() {
    return this.getPropertyValue("placeholder", "Select visit date");
  }

  set placeholder(val) {
    this.setPropertyValue("placeholder", val);
  }

  // Min date
  get minDate() {
    return this.getPropertyValue("minDate", "");
  }

  set minDate(val) {
    this.setPropertyValue("minDate", val);
  }

  // Max date
  get maxDate() {
    return this.getPropertyValue("maxDate", "");
  }

  set maxDate(val) {
    this.setPropertyValue("maxDate", val);
  }

  // Value
  get value() {
    return this.getPropertyValue("value");
  }

  set value(val) {
    this.setPropertyValue("value", val);
  }
}

/* =========================================================
   REACT RENDERER with Proper Icon Positioning
========================================================= */
const VisitDatePicker = (props) => {
  const q = props.question;

  if (!q) return <div>Loading...</div>;

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        type="date"
        value={q.value || ""}
        onChange={(e) => (q.value = e.target.value)}
        // placeholder={q.placeholder}
        disabled={q.isReadOnly}
        required={q.isRequired}
        min={q.minDate}
        max={q.maxDate}
        style={{
          width: "100%",
          padding: "8px 40px 25px 12px", // Extra right padding for icon
          border:
            q.errors?.length > 0 ? "1px solid #dc3545" : "1px solid #ced4da",
          borderRadius: "4px",
          backgroundColor: q.isReadOnly ? "#e9ecef" : "#fff",
          fontSize: "14px",
          boxSizing: "border-box",
          height: "38px",
          lineHeight: "22px",
          appearance: "none", // Remove default browser styling
          WebkitAppearance: "none",
          MozAppearance: "textfield",
        }}
      />
    </div>
  );
};

/* =========================================================
   REGISTRATION
========================================================= */
export function registerVisitDatePickerQuestion() {
  if (isRegistered) return;
  isRegistered = true;

  // Register with Serializer
  Serializer.addClass(
    QUESTION_TYPE,
    [
      {
        name: "placeholder",
        type: "text",
        category: "general",
        default: "Select visit date",
        visible: true,
      },
      {
        name: "minDate",
        type: "text",
        category: "date",
        displayName: "Earliest Date",
        visible: true,
        description: "Format: YYYY-MM-DD",
      },
      {
        name: "maxDate",
        type: "text",
        category: "date",
        displayName: "Latest Date",
        visible: true,
        description: "Format: YYYY-MM-DD",
      },
    ],
    () => new QuestionVisitDatePickerModel(""),
    "question"
  );

  // Register with QuestionFactory
  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionVisitDatePickerModel(name)
  );

  // Register React component
  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) => (
    <VisitDatePicker {...props} />
  ));
}

// Auto-register
registerVisitDatePickerQuestion();

export default QuestionVisitDatePickerModel;
